import React from 'react';

type UseTimeoutFnReturn = [() => boolean | null, () => void, () => void];

export const useTimeout = (fn: () => void, ms = 0): UseTimeoutFnReturn => {
  const ready = React.useRef<boolean | null>(false);
  const timeout = React.useRef<ReturnType<typeof setTimeout>>();
  const callback = React.useRef(fn);

  const isReady = React.useCallback(() => ready.current, []);

  const set = React.useCallback(() => {
    ready.current = false;
    timeout.current && clearTimeout(timeout.current);

    timeout.current = setTimeout(() => {
      ready.current = true;
      callback.current();
    }, ms);
  }, [ms]);

  const clear = React.useCallback(() => {
    ready.current = null;
    timeout.current && clearTimeout(timeout.current);
  }, []);

  React.useEffect(() => {
    callback.current = fn;
  }, [fn]);

  return [isReady, clear, set];
};
